<style scoped>

  @media only screen and (max-width: 990px) {
    .note-segment {
      min-height: 450px !important;
    }
  }

  @media only screen and (min-width: 991px) {    
    .note-segment {
      min-height: 570px !important;
    }      
  } 

</style>

<template>
  
  <div class="ui segment note-segment" :class="{ stacked, basic: !stacked }">

    <div v-if="note.severity == 'urgent'" class="ui red ribbon label"><i class="exclamation circle icon"></i> Urgente</div>
    <div v-if="note.severity == 'warning'" class="ui orange ribbon label"><i class="exclamation triangle icon"></i> Alerta</div>
    <div v-if="note.severity == 'info'" class="ui blue ribbon label"><i class="info circle icon"></i> Informativo</div>   

    <h4 class="text centered">{{ note.subject }}</h4>

    <div v-if="note.message" class="ui basic segment">
      <p class="grey bold text" v-html="note.message"></p>
    </div>   

    <div v-if="note.image" class="ui basic centered segment">
      <div class="ui large rounded image">          
        <img :src="note.image.url">          
      </div>
    </div>     

  </div>

</template>

<script>

  export default {
    
    name: "NoteSegment",

    props: {
      note: { required: true },
      stacked: { default: true },
      showDate: { default: false },
    },
  }

</script>